module.exports = __webpack_public_path__ + "static/media/marianna.9f04e345.jpg";